import { ReactElement } from "react";
import "./index.scss";

interface IProps {
  query: string | string[];
}

export const SearchPageHeader = ({ query }: IProps): ReactElement => {
  const isQueryString = typeof query === "string";
  document.title = `${isQueryString ? query : query.join(", ")} Porn GIFs and Pics | RedGIFs`;

  return (
    <div className="SearchPageHeader">
      <h1><b>{isQueryString ? query : query.join(" + ") }</b> Porn GIFs and Pics</h1>
    </div>
  );
};
